module.exports = __webpack_public_path__ + "img/horizontal_7_5_9005.99781167.png";